import { render, staticRenderFns } from "./imgTips.vue?vue&type=template&id=686f5007&scoped=true"
import script from "./imgTips.vue?vue&type=script&lang=js"
export * from "./imgTips.vue?vue&type=script&lang=js"
import style0 from "./imgTips.vue?vue&type=style&index=0&id=686f5007&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f5007",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686f5007')) {
      api.createRecord('686f5007', component.options)
    } else {
      api.reload('686f5007', component.options)
    }
    module.hot.accept("./imgTips.vue?vue&type=template&id=686f5007&scoped=true", function () {
      api.rerender('686f5007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/imgTips.vue"
export default component.exports